// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24u6l","importantInfo":"styles_importantInfo__3wEHV"};